import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/crossCountry',
    children: [
      {
        path: 'tank',
        name: 'Tank',
        meta: {
          title: '越野分级企业标准',
          keepAlive: true,
          isApp: true,
          auth: false,
        },
        component: () => import('@/views/crossCountry/tankcross.vue'),
      },
      {
        path: 'rankingList', // 越野分级车型排名
        name: 'rankingList',
        meta: {
          title: '越野车型分级',
          isApp: true,
          auth: false,
        },
        component: () => import('@/views/crossCountry/rankingList.vue'),
      },
      {
        path: 'detail', // 越野分级
        name: 'detail',
        meta: {
          title: '车型分级详解',
          isApp: true,
          auth: false,
        },
        component: () => import('@/views/crossCountry/detail.vue'),
      },
      {
        path: 'testPaper', // 趣味测试
        name: 'testPaper',
        meta: {
          title: '互动测试',
          isApp: true,
          auth: false,
        },
        component: () => import('@/views/crossCountry/testPaper.vue'),
      },
      {
        path: 'testResult', // 测评结果
        name: 'testResult',
        meta: {
          title: '测评结果',
          isApp: true,
          auth: false,
        },
        component: () => import('@/views/crossCountry/testResult.vue'),
      },
      {
        path: 'explain',
        name: 'explain',
        meta: {
          title: ' 一图读懂Hi4Z',
          isApp: true,
          auth: false,
        },
        component: () => import('@/views/crossCountry/explain.vue'),
      },
    ],
  },
]

export default routes
